import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { seoForPath, SITE_ORIGIN } from '@/data/seo';

/**
 * Keeps <title>, <meta description>, canonical, og: and twitter: tags in sync
 * with the current React Router route. Runs at app level, so no per-page code needed.
 */
export default function SeoTags() {
  const { pathname } = useLocation();

  useEffect(() => {
    const { title, description, path } = seoForPath(pathname);
    const url = `${SITE_ORIGIN}${path === '/' ? '/' : path}`;

    document.title = title;

    const upsert = (selector, attr, value) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement(selector.startsWith('meta') ? 'meta' : 'link');
        // Extract attributes from selector like meta[name="description"] or link[rel="canonical"]
        const [tag, rest] = selector.match(/^(\w+)\[(.+)\]$/).slice(1);
        rest.split('][').forEach((part) => {
          const [k, v] = part.replace(/["\]]/g, '').split('=');
          el.setAttribute(k, v);
        });
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    upsert('meta[name="description"]', 'content', description);
    upsert('link[rel="canonical"]', 'href', url);

    upsert('meta[property="og:title"]', 'content', title);
    upsert('meta[property="og:description"]', 'content', description);
    upsert('meta[property="og:url"]', 'content', url);

    upsert('meta[name="twitter:title"]', 'content', title);
    upsert('meta[name="twitter:description"]', 'content', description);
  }, [pathname]);

  return null;
}
